/**
 * Wrapper around Magnetic select to add name prop to it.
 */

import React from "react";

import { Select as MagneticSelect } from "@magnetic/select";
import { SelectProps as MagneticSelectProps } from "@magnetic/select/dist/types/types";

interface SelectProps extends MagneticSelectProps {
  readonly name: string;
}
export type Ref = HTMLDivElement;
export const Select = React.forwardRef<Ref, SelectProps>((props, ref) => {
  return <MagneticSelect ref={ref} {...props} />;
});
